/** Player-name display helpers. Display only — never use these for lookups or keys. */

const clean = (s: string | null | undefined): string => (s == null ? '' : String(s).trim());

/** "Nicholas" + "Destounis" → "Nicholas Destounis" (tolerates a missing half). */
export function fullName(first?: string | null, last?: string | null): string {
  return [clean(first), clean(last)].filter(Boolean).join(' ');
}

/**
 * "Nicholas" + "Destounis" → "N. Destounis". Missing first → last name only;
 * missing last → first name only. The initial is the first code point, so
 * accented / astral characters stay intact ("Élias" → "É.").
 */
export function shortName(first?: string | null, last?: string | null): string {
  const f = clean(first);
  const l = clean(last);
  if (!f) return l;
  if (!l) return f;
  const initial = (Array.from(f)[0] || '').toUpperCase();
  return `${initial}. ${l}`;
}

/**
 * "Nicholas Destounis" → "N. Destounis"; "Nick Van Der Berg" → "N. Van Der Berg"
 * (split at the FIRST space, everything after it is the surname); "Cher" → "Cher".
 */
export function shortNameFromFull(full?: string | null): string {
  const s = clean(full);
  const i = s.indexOf(' ');
  if (i < 0) return s;
  return shortName(s.slice(0, i), s.slice(i + 1));
}
